import * as yup from "yup"
import moment from "moment"
import { fetchPromo } from "../../lib/actions"

export const createSearchFormSchema = (inventory) => yup.object().shape({
    departure: yup.string().required("Departure location is required"),
    arrival: yup.string().required("Arrival location is required"),
    promoCode: yup.string()
        .required("Promo Code is required")
        .matches(/^\S+$/, "Promo Code cannot contain spaces")
        .test("is-valid-promo-code", "Invalid promo code", async function (value) {
            const promo = await fetchPromo(value)
            return promo && promo.isActive && moment().isSameOrBefore(moment(promo.expirationDate).endOf('day')) && promo.redeemLimit > (promo.redeemed || 0)
        }),
    departureDate: yup
        .string()
        .required("Departure date is required for one-way trip")
        .transform((value, originalValue) => {
            return originalValue ? moment(originalValue).format("YYYY-MM-DD") : null
        })
        .test("is-valid-date", "Invalid date format", (value) =>
            moment(value, "YYYY-MM-DD", true).isValid()
        )
        .test("is-future-date", "Departure date cannot be in the past", (value) =>
            moment(value).isSameOrAfter(moment().startOf("day"))
        )
        .test("is-date-available", "Departure date is not available", function (value) {
            if (!inventory) return false
            const { departure, arrival, passengerCount } = this.parent
            const ticketFound = inventory.find(
                (item) =>
                    item.departure === departure &&
                    item.arrival === arrival &&
                    item.departureDate === value &&
                    item.availableTickets >= passengerCount
            )?.departureDate || null

            return ticketFound === value
        }),
    returnDate: yup
        .string()
        .nullable()
        .transform((value, originalValue) => {
            return originalValue ? moment(originalValue).format("YYYY-MM-DD") : null
        })
        .when("tripType", {
            is: "round-trip",
            then: (schema) =>
                schema
                    .required("Return date is required for round-trip")
                    .test("is-after-departure", "Return date must be after departure date", function (value) {
                        const { departureDate } = this.parent
                        return value && moment(value).isAfter(departureDate)
                    }),
            otherwise: (schema) => schema.notRequired(),
        })
        .test("is-valid-date", "Invalid date format", (value) =>
            value ? moment(value, "YYYY-MM-DD", true).isValid() : true
        )
        .test("is-date-available", "Return date is not available", function (value) {
            if (!value || this.parent.tripType !== 'round-trip' || !inventory) return true

            const { departure, arrival, passengerCount } = this.parent
            const ticketFound = inventory.find(
                (item) =>
                    item.departure === arrival &&
                    item.arrival === departure &&
                    item.departureDate === value &&
                    item.availableTickets >= passengerCount
            )?.departureDate || null

            return ticketFound === value
        }),
    passengerCount: yup
        .number()
        .required("At least 1 passenger is required")
        .min(1, "At least 1 passenger is required"),
    tripType: yup.string().required("Trip type is required"),
})